import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const otpVerificadaGuard: CanActivateFn = async (route, state) => {
  //? Inyección de dependencias
  const auth = inject(AuthService);
  const router = inject(Router);

  const usuario = await auth.returnUserInfo();
  if (usuario) {
    const { loginLogs = [] } = usuario;

    if (loginLogs.length > 0) {
      const log = loginLogs[0];
      if (log.mk) return true;
      else if (log.otpVerificada) return true;
      else {
        router.navigate(['clave']);
        return false;
      }
    } else {
      return true;
    }
  }
  router.navigate(['ingresar']);
  return false;
};
